function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * vue-simple-spinner v1.2.10 (https://github.com/dzwillia/vue-simple-spinner)
 * (c) 2018 David Z. Williams
 * Released under the MIT License.
 */
(function webpackUniversalModuleDefinition(root, factory) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') exports["VueSimpleSpinner"] = factory();else root["VueSimpleSpinner"] = factory();
})(this, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 0);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.VueSimpleSpinner = undefined;

      var _Spinner = __webpack_require__(1);

      var _Spinner2 = _interopRequireDefault(_Spinner);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      if (typeof window !== 'undefined' && window.Vue) {
        Vue.component('vue-simple-spinner', _Spinner2.default);
      }

      exports.VueSimpleSpinner = _Spinner2.default;
      exports.default = _Spinner2.default;
      /***/
    },
    /* 1 */

    /***/
    function (module, exports, __webpack_require__) {
      /* styles */
      __webpack_require__(2);

      var Component = __webpack_require__(7)(
      /* script */
      __webpack_require__(8),
      /* template */
      __webpack_require__(9),
      /* scopeId */
      null,
      /* cssModules */
      null);

      module.exports = Component.exports;
      /***/
    },
    /* 2 */

    /***/
    function (module, exports, __webpack_require__) {
      // style-loader: Adds some css to the DOM by adding a <style> tag
      // load the styles
      var content = __webpack_require__(3);

      if (typeof content === 'string') content = [[module.i, content, '']];
      if (content.locals) module.exports = content.locals; // add the styles to the DOM

      var update = __webpack_require__(5)("d89557e4", content, true);
      /***/

    },
    /* 3 */

    /***/
    function (module, exports, __webpack_require__) {
      exports = module.exports = __webpack_require__(4)(); // imports
      // module

      exports.push([module.i, ".vue-simple-spinner{transition:all .3s linear}@keyframes vue-simple-spinner-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]); // exports

      /***/
    },
    /* 4 */

    /***/
    function (module, exports) {
      /*
      	MIT License http://www.opensource.org/licenses/mit-license.php
      	Author Tobias Koppers @sokra
      */
      // css base code, injected by the css-loader
      module.exports = function () {
        var list = []; // return the list of modules as css string

        list.toString = function toString() {
          var result = [];

          for (var i = 0; i < this.length; i++) {
            var item = this[i];

            if (item[2]) {
              result.push("@media " + item[2] + "{" + item[1] + "}");
            } else {
              result.push(item[1]);
            }
          }

          return result.join("");
        }; // import a list of modules into the list


        list.i = function (modules, mediaQuery) {
          if (typeof modules === "string") modules = [[null, modules, ""]];
          var alreadyImportedModules = {};

          for (var i = 0; i < this.length; i++) {
            var id = this[i][0];
            if (typeof id === "number") alreadyImportedModules[id] = true;
          }

          for (i = 0; i < modules.length; i++) {
            var item = modules[i]; // skip already imported module
            // this implementation is not 100% perfect for weird media query combinations
            //  when a module is imported multiple times with different media queries.
            //  I hope this will never occur (Hey this way we have smaller bundles)

            if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
              if (mediaQuery && !item[2]) {
                item[2] = mediaQuery;
              } else if (mediaQuery) {
                item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
              }

              list.push(item);
            }
          }
        };

        return list;
      };
      /***/

    },
    /* 5 */

    /***/
    function (module, exports, __webpack_require__) {
      /*
        MIT License http://www.opensource.org/licenses/mit-license.php
        Author Tobias Koppers @sokra
        Modified by Evan You @yyx990803
      */
      var hasDocument = typeof document !== 'undefined';

      if (typeof DEBUG !== 'undefined' && DEBUG) {
        if (!hasDocument) {
          throw new Error('vue-style-loader cannot be used in a non-browser environment. ' + "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");
        }
      }

      var listToStyles = __webpack_require__(6);
      /*
      type StyleObject = {
        id: number;
        parts: Array<StyleObjectPart>
      }
      
      type StyleObjectPart = {
        css: string;
        media: string;
        sourceMap: ?string
      }
      */


      var stylesInDom = {
        /*
        [id: number]: {
        id: number,
        refs: number,
        parts: Array<(obj?: StyleObjectPart) => void>
        }
        */
      };
      var head = hasDocument && (document.head || document.getElementsByTagName('head')[0]);
      var singletonElement = null;
      var singletonCounter = 0;
      var isProduction = false;

      var noop = function noop() {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
      // tags it will allow on a page


      var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());

      module.exports = function (parentId, list, _isProduction) {
        isProduction = _isProduction;
        var styles = listToStyles(parentId, list);
        addStylesToDom(styles);
        return function update(newList) {
          var mayRemove = [];

          for (var i = 0; i < styles.length; i++) {
            var item = styles[i];
            var domStyle = stylesInDom[item.id];
            domStyle.refs--;
            mayRemove.push(domStyle);
          }

          if (newList) {
            styles = listToStyles(parentId, newList);
            addStylesToDom(styles);
          } else {
            styles = [];
          }

          for (var i = 0; i < mayRemove.length; i++) {
            var domStyle = mayRemove[i];

            if (domStyle.refs === 0) {
              for (var j = 0; j < domStyle.parts.length; j++) {
                domStyle.parts[j]();
              }

              delete stylesInDom[domStyle.id];
            }
          }
        };
      };

      function addStylesToDom(styles
      /* Array<StyleObject> */
      ) {
        for (var i = 0; i < styles.length; i++) {
          var item = styles[i];
          var domStyle = stylesInDom[item.id];

          if (domStyle) {
            domStyle.refs++;

            for (var j = 0; j < domStyle.parts.length; j++) {
              domStyle.parts[j](item.parts[j]);
            }

            for (; j < item.parts.length; j++) {
              domStyle.parts.push(addStyle(item.parts[j]));
            }

            if (domStyle.parts.length > item.parts.length) {
              domStyle.parts.length = item.parts.length;
            }
          } else {
            var parts = [];

            for (var j = 0; j < item.parts.length; j++) {
              parts.push(addStyle(item.parts[j]));
            }

            stylesInDom[item.id] = {
              id: item.id,
              refs: 1,
              parts: parts
            };
          }
        }
      }

      function createStyleElement() {
        var styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        head.appendChild(styleElement);
        return styleElement;
      }

      function addStyle(obj
      /* StyleObjectPart */
      ) {
        var update, remove;
        var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]');

        if (styleElement) {
          if (isProduction) {
            // has SSR styles and in production mode.
            // simply do nothing.
            return noop;
          } else {
            // has SSR styles but in dev mode.
            // for some reason Chrome can't handle source map in server-rendered
            // style tags - source maps in <style> only works if the style tag is
            // created and inserted dynamically. So we remove the server rendered
            // styles and inject new ones.
            styleElement.parentNode.removeChild(styleElement);
          }
        }

        if (isOldIE) {
          // use singleton mode for IE9.
          var styleIndex = singletonCounter++;
          styleElement = singletonElement || (singletonElement = createStyleElement());
          update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
          remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
        } else {
          // use multi-style-tag mode in all other cases
          styleElement = createStyleElement();
          update = applyToTag.bind(null, styleElement);

          remove = function remove() {
            styleElement.parentNode.removeChild(styleElement);
          };
        }

        update(obj);
        return function updateStyle(newObj
        /* StyleObjectPart */
        ) {
          if (newObj) {
            if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
              return;
            }

            update(obj = newObj);
          } else {
            remove();
          }
        };
      }

      var replaceText = function () {
        var textStore = [];
        return function (index, replacement) {
          textStore[index] = replacement;
          return textStore.filter(Boolean).join('\n');
        };
      }();

      function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? '' : obj.css;

        if (styleElement.styleSheet) {
          styleElement.styleSheet.cssText = replaceText(index, css);
        } else {
          var cssNode = document.createTextNode(css);
          var childNodes = styleElement.childNodes;
          if (childNodes[index]) styleElement.removeChild(childNodes[index]);

          if (childNodes.length) {
            styleElement.insertBefore(cssNode, childNodes[index]);
          } else {
            styleElement.appendChild(cssNode);
          }
        }
      }

      function applyToTag(styleElement, obj) {
        var css = obj.css;
        var media = obj.media;
        var sourceMap = obj.sourceMap;

        if (media) {
          styleElement.setAttribute('media', media);
        }

        if (sourceMap) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

          css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */';
        }

        if (styleElement.styleSheet) {
          styleElement.styleSheet.cssText = css;
        } else {
          while (styleElement.firstChild) {
            styleElement.removeChild(styleElement.firstChild);
          }

          styleElement.appendChild(document.createTextNode(css));
        }
      }
      /***/

    },
    /* 6 */

    /***/
    function (module, exports) {
      /**
       * Translates the list format produced by css-loader into something
       * easier to manipulate.
       */
      module.exports = function listToStyles(parentId, list) {
        var styles = [];
        var newStyles = {};

        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          var id = item[0];
          var css = item[1];
          var media = item[2];
          var sourceMap = item[3];
          var part = {
            id: parentId + ':' + i,
            css: css,
            media: media,
            sourceMap: sourceMap
          };

          if (!newStyles[id]) {
            styles.push(newStyles[id] = {
              id: id,
              parts: [part]
            });
          } else {
            newStyles[id].parts.push(part);
          }
        }

        return styles;
      };
      /***/

    },
    /* 7 */

    /***/
    function (module, exports) {
      // this module is a runtime utility for cleaner component module output and will
      // be included in the final webpack user bundle
      module.exports = function normalizeComponent(rawScriptExports, compiledTemplate, scopeId, cssModules) {
        var esModule;
        var scriptExports = rawScriptExports = rawScriptExports || {}; // ES6 modules interop

        var type = _typeof(rawScriptExports.default);

        if (type === 'object' || type === 'function') {
          esModule = rawScriptExports;
          scriptExports = rawScriptExports.default;
        } // Vue.extend constructor export interop


        var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports; // render functions

        if (compiledTemplate) {
          options.render = compiledTemplate.render;
          options.staticRenderFns = compiledTemplate.staticRenderFns;
        } // scopedId


        if (scopeId) {
          options._scopeId = scopeId;
        } // inject cssModules


        if (cssModules) {
          var computed = Object.create(options.computed || null);
          Object.keys(cssModules).forEach(function (key) {
            var module = cssModules[key];

            computed[key] = function () {
              return module;
            };
          });
          options.computed = computed;
        }

        return {
          esModule: esModule,
          exports: scriptExports,
          options: options
        };
      };
      /***/

    },
    /* 8 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var isNumber = function isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
      };

      exports.default = {
        props: {
          'size': {
            default: 32
          },
          'line-size': {
            type: Number,
            default: 3
          },
          'line-bg-color': {
            type: String,
            default: '#eee'
          },
          'line-fg-color': {
            type: String,
            default: '#2196f3'
          },
          'speed': {
            type: Number,
            default: 0.8
          },
          'spacing': {
            type: Number,
            default: 4
          },
          'message': {
            type: String,
            default: ''
          },
          'font-size': {
            type: Number,
            default: 13
          },
          'text-fg-color': {
            type: String,
            default: '#555'
          }
        },
        computed: {
          size_px: function size_px() {
            switch (this.size) {
              case 'tiny':
                return 12;

              case 'small':
                return 16;

              case 'medium':
                return 32;

              case 'large':
                return 48;

              case 'big':
                return 64;

              case 'huge':
                return 96;

              case 'massive':
                return 128;
            }

            return isNumber(this.size) ? this.size : 32;
          },
          line_size_px: function line_size_px() {
            switch (this.size) {
              case 'tiny':
                return 1;

              case 'small':
                return 2;

              case 'medium':
                return 3;

              case 'large':
                return 3;

              case 'big':
                return 4;

              case 'huge':
                return 4;

              case 'massive':
                return 5;
            }

            return isNumber(this.lineSize) ? this.lineSize : 4;
          },
          text_margin_top: function text_margin_top() {
            switch (this.size) {
              case 'tiny':
              case 'small':
              case 'medium':
              case 'large':
              case 'big':
              case 'huge':
              case 'massive':
                return Math.min(Math.max(Math.ceil(this.size_px / 8), 3), 12);
            }

            return isNumber(this.spacing) ? this.spacing : 4;
          },
          text_font_size: function text_font_size() {
            switch (this.size) {
              case 'tiny':
              case 'small':
              case 'medium':
              case 'large':
              case 'big':
              case 'huge':
              case 'massive':
                return Math.min(Math.max(Math.ceil(this.size_px * 0.4), 11), 32);
            }

            return isNumber(this.fontSize) ? this.fontSize : 13;
          },
          spinner_style: function spinner_style() {
            return {
              'margin': '0 auto',
              'border-radius': '100%',
              'border': this.line_size_px + 'px solid ' + this.lineBgColor,
              'border-top': this.line_size_px + 'px solid ' + this.lineFgColor,
              'width': this.size_px + 'px',
              'height': this.size_px + 'px',
              'animation': 'vue-simple-spinner-spin ' + this.speed + 's linear infinite'
            };
          },
          text_style: function text_style() {
            return {
              'margin-top': this.text_margin_top + 'px',
              'color': this.textFgColor,
              'font-size': this.text_font_size + 'px',
              'text-align': 'center'
            };
          }
        }
      };
      /***/
    },
    /* 9 */

    /***/
    function (module, exports) {
      module.exports = {
        render: function render() {
          var _vm = this;

          var _h = _vm.$createElement;

          var _c = _vm._self._c || _h;

          return _c('div', [_c('div', {
            staticClass: "vue-simple-spinner",
            style: _vm.spinner_style
          }), _vm._v(" "), _vm.message.length > 0 ? _c('div', {
            staticClass: "vue-simple-spinner-text",
            style: _vm.text_style
          }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()]);
        },
        staticRenderFns: []
      };
      /***/
    }
    /******/
    ])["default"]
  );
});